import { render, staticRenderFns } from "./HotEventScatter.vue?vue&type=template&id=72ec7d4a"
import script from "./HotEventScatter.vue?vue&type=script&lang=js"
export * from "./HotEventScatter.vue?vue&type=script&lang=js"
import style0 from "./HotEventScatter.vue?vue&type=style&index=0&id=72ec7d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports